export const cdRelatorioDeVencimentoDeContratoPorEmpresa = 1;
export const cdRelatorioDeContratosPorNuLinha= 2;

export const stripContractReportLayout = [ // deprecated?
  { label: 'Vencimento de contrato por empresa', value: cdRelatorioDeVencimentoDeContratoPorEmpresa },
  { label: 'Contratos por nº da linha', value: cdRelatorioDeContratosPorNuLinha },
]

export const contractRequestColumnExhibitionOptions = [ // deprecated?
  { label: 'Exibir empresa anterior', name: 'boExibirEmpresaAnterior ' },
  { label: 'Exibir observações', name: 'boExibirObservacoes' },
];

export const situacoesLinha = [
  { label: "Ativas", value: 1 },
  { label: "Inativas", value: 2 },
  { label: "Todas", value: 3 }
];
